import { InvoicesTranslation } from 'locales/de/pages/Jobmarket/invoices';

const en: InvoicesTranslation = {
  alerts: {
    saveSuccessful: 'Invoice successfully created.',
    saveFailed: 'Invoice could not be created.',
    importNotAllowed: 'You did not grant permission to access your clipboard',
    importFailed: 'There was an error during import: {{cause}}',
    noImportResult: 'There were no valid numbers in your clipboard.',
    importSuccess: 'Import was successful.',
    errorLoading: 'Rechnungen konnten nicht geladen werden.',
    importEmpty: 'Import is empty.',
    cancelRequestSuccess: 'The change request was successfully created.',
    cancelRequestError: 'The change request could not be created.',
    processCancelRequestSuccess: 'The change request was processed.',
    processCancelRequestError: 'The change request could not be processed.',
    processInvoiceSuccess: 'The invoice was successfully processed.',
    processInvoiceError: 'The invoice could not be proccessed.'
  },
  create: {
    title: 'New Invoice for company "{{company.name}}"'
  },
  steps: {
    customerSearch: 'Customer Search',
    offers: 'Job Offers',
    periods: 'Display Periods',
    invoiceSettings: 'Invoice Settings'
  },
  tabs: {
    openOffers: 'Open offers',
    existingInvoices: 'Existing invoices',
    openChangeRequests: 'Change requests',
    paidInvoices: 'Paid invoices'
  },
  customerInFSV: 'Found FSV customer',
  jobmarketCustomer: 'Job market company data',
  noCustomerFound: 'No suitable customer found',
  noCustomerSelected: 'No customer selected',

  noCustomerInfoText:
    'When the ‘No suitable customer found’ button is clicked, the customer data is taken from the ‘Job Exchange Company Data’. The outgoing invoice tool then attempts to find this customer in the database using the following values: first name, last name, email, company name, VAT ID, address. If these values do not match any of the stored customers, a new customer is created with the payment partner ID 0.',

  selectedOffersCount: '{{selected}} of {{total}} job offers selected for billing',
  selectedPeriodsCount: '{{selected}} of {{total}} offer periods selected for billing',
  disabledJobOffers: {
    disabledPeriodsWarningTitle: 'Note',
    disabledPeriodsWarning:
      'Grayed-out job offers cannot be settled within the three-day grace period. During this period, the company has the option of changing the job type of the vacancies.',
    disabledPeriodsTooltip:
      'The job offer cannot be settled within the three-day grace period. During this period, the company has the option of changing the job type of the job offer.'
  },
  invoiceAddress: 'Invoice address',
  taxInformation: 'Tax information',
  invoiceEmail: 'Invoice email',
  taxId: 'VAT Reg No.',
  taxNumber: 'Tax number',
  ksNumber: 'KS number',
  stokNumber: 'STOK number',
  ksNumbersLeft: '{{left}} KS numbers left',
  stokNumbersLeft: '{{left}} STOK numbers left',
  earliestPeriod: 'Earliest period',
  periodCount: 'Period count',
  periodId: 'Period-ID',
  offerId: 'Offer-ID',
  offerIdTitle: 'Offer-ID [Title]',
  companyId: 'Company-ID',
  openOffers: 'Periods for invoicing',
  openAmount: 'Open amount',
  actions: 'Actions',
  createInvoice: 'Create invoice',
  invoiceId: 'Invoice-ID',
  createdAt: 'Invoice Date',
  amount: 'Amount',
  noInvoicesToCreate: 'No invoices available for billing.',
  noInvoices: 'No invoices to display. Maybe you need to change your filter settings.',
  changeInvoice: 'Change Request',
  changeInvoicePlaceholder: 'Please provide your change reason here',
  changeInvoiceDescription: 'Please provide a reason why we should change your invoice.',
  changeReason: 'Change reason',
  changeState: 'Change state',
  changeStates: {
    pending: 'Pending',
    accepted: 'Change Accepted'
  },
  denyChangeDescription: 'Do you want to cancel the invoice?',
  acceptChangeDescription: 'Did you edit the invoice and want it to recreate?',
  markAsPaid: 'Mark as Paid',
  markAsUnpaid: 'Mark as unpaid',
  markInvoiceAsPaidTitle: 'Invoice paid',
  markInvoiceAsPaidDescription: 'Do you want to mark this invoice as paid?',
  importModalTitle: 'Import STOK-/KS-number',
  allowClipboardPermissionTitle: 'Grant permission to read from clipboard',
  allowClipboardPermission:
    'After confirming this dialog, the browser will ask you for permission to read from your clipboard. You need to grant this request in order to enable the import. The data will be processed locally and only be sent to the server when it is valid. This will not result in privacy issues for you.',
  permissionDeniedTitle: 'No permission',
  permissionDenied:
    'You need to grant permission to read from your clipboard for the import to work. The solution for this problem depends on your browser. Please ask the "Rechenzentrum" for help or find a solution via google.',
  recreate: 'Recreate',
  paidOn: 'Payment received on: {{date}}',
  paymentDate: 'Payment date',
  cancel: 'Cancel',
  editAndRecreate: 'Edit and Recreate',
  invoice: 'Invoice',
  cancelInvoice: 'Cancel-Invoice',
  openInDMS: 'Open in DMS'
};
export default en;
